import Mentions from './Mentions';
export default Mentions;


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-mentions/es/index.js
// module id = 1532
// module chunks = 0